import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentSpecialFreightMainInfoService } from './shipment-special-freight-main-info.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import {
  ShipmentSpecialFreightOverview,
  ShipmentSpecialFreightOverviewSetInitialState,
} from './shipment-special-freight-main-info.actions';
import { SpecialFreightOverviewModel } from '../../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentSpecialFreightOverviewStateModel {
  overview: SpecialFreightOverviewModel;
  loaded: boolean;
}

const initialState: ShipmentSpecialFreightOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<ShipmentSpecialFreightOverviewStateModel>({
  name: 'shipmentSpecialFreightOverview',
  defaults: initialState,
})
@Injectable()
export class ShipmentSpecialFreightMainInfoState {
  constructor(
    private shipmentSpecialFreightMainInfoService: ShipmentSpecialFreightMainInfoService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentSpecialFreightOverviewStateModel): ShipmentSpecialFreightOverviewStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentSpecialFreightOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getOverview(state: ShipmentSpecialFreightOverviewStateModel): SpecialFreightOverviewModel {
    return state.overview;
  }

  @Action(ShipmentSpecialFreightOverview)
  getShipmentSpecialFreightOverview(
    ctx: StateContext<ShipmentSpecialFreightOverviewStateModel>,
    { payload }: ShipmentSpecialFreightOverview,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentSpecialFreightMainInfoService.getOverviewData(payload).pipe(
      map((overview: SpecialFreightOverviewModel) => {
        ctx.patchState({ overview, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentSpecialFreightOverviewSetInitialState)
  setInitialState(ctx: StateContext<ShipmentSpecialFreightOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
